/* eslint-disable import/no-duplicates */ function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __generator = this && this.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
import React, { useState, useEffect, useCallback, useMemo } from "react";
import en from "date-fns/locale/en-US";
import fr from "date-fns/locale/fr-CA";
import de from "date-fns/locale/de";
import pt from "date-fns/locale/pt-BR";
import es from "date-fns/locale/es";
import storageKeys from "../../types/localStorageKeys";
import { update as updateFn, retrieve as retrieveFn } from "../../services/session-service";
import { getDefaultLanguage, setLocale as setLocaleFn, ISO_LOCALE_MAP } from "../../services/translation/api";
import Context from "./context";
import AntDTranslationProvider from "./AntDProvider";
var _obj;
var ISO_DATE_LOCALE = (_obj = {}, _defineProperty(_obj, ISO_LOCALE_MAP.en, en), _defineProperty(_obj, ISO_LOCALE_MAP.fr_CA, fr), _defineProperty(_obj, ISO_LOCALE_MAP.pt_BR, pt), _defineProperty(_obj, ISO_LOCALE_MAP.de, de), _defineProperty(_obj, ISO_LOCALE_MAP.es, es), _obj);
/**
 * A context provider for the translation (language and locale). You can access
 * the context with common/hooks/useTranslation.
 */ var TranslationProvider = function(param) {
    var _param_suffix = param.suffix, suffix = _param_suffix === void 0 ? "" : _param_suffix, children = param.children;
    var defaultLanguage = getDefaultLanguage();
    var _useState = _slicedToArray(useState({
        language: defaultLanguage,
        locale: ISO_LOCALE_MAP[defaultLanguage],
        dateLocale: ISO_DATE_LOCALE[defaultLanguage]
    }), 2), stored = _useState[0], setStored = _useState[1];
    var updateStored = useCallback(function() {
        var _ref = _asyncToGenerator(function(language) {
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            setLocaleFn(language, suffix)
                        ];
                    case 1:
                        _state.sent();
                        setStored({
                            language: language,
                            locale: ISO_LOCALE_MAP[language],
                            dateLocale: ISO_DATE_LOCALE[ISO_LOCALE_MAP[language]]
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function(language) {
            return _ref.apply(this, arguments);
        };
    }(), [
        suffix
    ]);
    useEffect(function() {
        function effect() {
            return _effect.apply(this, arguments);
        }
        function _effect() {
            _effect = _asyncToGenerator(function() {
                var _ref, language;
                return __generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                retrieveFn()
                            ];
                        case 1:
                            language = ((_ref = _state.sent()) === null || _ref === void 0 ? void 0 : _ref.language) || getDefaultLanguage();
                            return [
                                4,
                                updateStored(language)
                            ];
                        case 2:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return _effect.apply(this, arguments);
        }
        effect();
    }, [
        updateStored
    ]);
    var setLanguage = useCallback(function() {
        var _ref = _asyncToGenerator(function(language) {
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            Promise.all([
                                updateStored(language),
                                updateFn({
                                    language: language
                                })
                            ])
                        ];
                    case 1:
                        _state.sent();
                        // TODO: Remove this once we're fully off Angular
                        // This will set the language for Angular pages to use
                        window.localStorage.setItem(storageKeys.language, language);
                        return [
                            2
                        ];
                }
            });
        });
        return function(language) {
            return _ref.apply(this, arguments);
        };
    }(), [
        updateStored
    ]);
    var value = useMemo(function() {
        return _objectSpreadProps(_objectSpread({}, stored), {
            setLanguage: setLanguage
        });
    }, [
        stored,
        setLanguage
    ]);
    return /*#__PURE__*/ React.createElement(Context.Provider, {
        value: value
    }, /*#__PURE__*/ React.createElement(AntDTranslationProvider, {
        locale: stored.locale
    }, children));
};
export default TranslationProvider;
